import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import noop from "lodash-es/noop";
import { BEMClasses } from "utils/index";

const Tag = ({ icon, text, controls, onClick, type, modificators }) => {
    return (
        <div
            className={cn(
                "tag",
                { [`tag_${type}`]: !!type },
                BEMClasses("tag", modificators.container)
            )}
            onClick={onClick}
        >
            {!!icon && (
                <div className={BEMClasses("tag__icon", modificators.icon)}>
                    {icon}
                </div>
            )}

            {!!text && (
                <div className={BEMClasses("tag__name", modificators.name)}>
                    {text}
                </div>
            )}

            {!!controls && (
                <div
                    className={BEMClasses(
                        "tag__controls",
                        modificators.controls
                    )}
                >
                    {controls}
                </div>
            )}
        </div>
    );
};

Tag.defaultProps = {
    onClick: noop,
    modificators: {},
};

Tag.propTypes = {
    text: PropTypes.string,
    icon: PropTypes.any,
    controls: PropTypes.any,
    onClick: PropTypes.func,
    type: PropTypes.oneOf(["alert"]),
    modificators: PropTypes.shape({
        container: PropTypes.arrayOf(PropTypes.string),
        icon: PropTypes.arrayOf(PropTypes.string),
        name: PropTypes.arrayOf(PropTypes.string),
        controls: PropTypes.arrayOf(PropTypes.string),
    }),
};

export default Tag;
